import { LayoutGroup, motion } from "framer-motion";

// Pill filter tabs with an animated active background. Used on /case-studies and /news.
export const FilterTabs = ({ filters, active, onSelect, countFor, label, testIdPrefix }) => (
  <LayoutGroup id={testIdPrefix}>
    <div role="tablist" aria-label={label} className="flex flex-wrap gap-2" data-testid={`${testIdPrefix}-filters`}>
      {filters.map((f) => {
        const on = active === f.id;
        return (
          <button
            key={f.id}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onSelect(f.id)}
            className={`relative rounded-none border px-5 py-2.5 text-[14px] font-medium transition-colors duration-300 ${on ? "border-ink text-paper" : "border-line text-ink hover:border-ink/50"}`}
            data-testid={`${testIdPrefix}-filter-${f.id}`}
          >
            {on && <motion.span layoutId={`${testIdPrefix}-filter-pill`} className="absolute inset-0 rounded-none bg-ink" transition={{ type: "spring", stiffness: 380, damping: 32 }} />}
            <span className="relative">
              {f.label} <span className={on ? "text-paper/70" : "text-muted"}>{countFor(f.id)}</span>
            </span>
          </button>
        );
      })}
    </div>
  </LayoutGroup>
);
